import {FormikErrors, useField, useFormikContext} from "formik";
import { Form, FormControl } from "react-bootstrap";
import {forwardRef, ReactNode, useEffect, useRef} from "react";
import { IBaseComponentProps } from "./types";
import clsx from "clsx";
import './style.scss';
import {LABEL_POSITION} from "../utils/Constant";

interface TextFieldProps extends IBaseComponentProps {
  labelClassName?: string;
  inputClassName?: string;
  labelPosition?: string;
  errors?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
  isInvalid?: boolean;
  [key: string]: any;
}

const TextField: React.FC<TextFieldProps> = forwardRef<
  HTMLInputElement,
  TextFieldProps
>(({ 
  labelClassName, 
  inputClassName, 
  containerClassName,
  readOnlyText, 
  variant = 'outlined',
  readOnly,
  ...props 
}, ref) => {
  const [field, meta] = useField(props?.name ?? '');
  const { submitCount, isSubmitting } = useFormikContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const fieldClassName = clsx(
    'spaces px-4 customs-input',
    {
      'is-invalid':(meta.error && meta.touched) || (props?.errors && props?.touched),
    },
    inputClassName,
    props.className,
    `oct-text-field--${variant}`
  );

  useEffect(() => {
    if ((meta.error && meta.touched) || submitCount > 0 || isSubmitting) {
      const invalidElements = document.querySelectorAll(".is-invalid");
      if (invalidElements.length > 0) {
        const firstInvalidElement = invalidElements[0] as HTMLElement;
        firstInvalidElement.focus();
        firstInvalidElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount, isSubmitting]);

  return (
		<Form.Group
			className={clsx(
        'oct-field-wrapper',
        props.labelPosition === LABEL_POSITION.TOP ? '' : 'text-field-v2',
        props?.className, containerClassName
      )}
		>
			{props?.label && !props?.hideLabel && (
				<Form.Label

					className={clsx(
						'text-lable-input max-content-width min-w-fit-content mb-0 spaces',
						{
							'me-2': !labelClassName,
						},
						labelClassName
					)}
				>
					{props?.label}
				</Form.Label>
			)}

			<div className="position-relative w-100 h-100">
				<FormControl
					{...field}
					{...props}
					ref={ref || inputRef}
					readOnly={readOnlyText || readOnly}
					className={fieldClassName}
				/>
				<Form.Control.Feedback type="invalid" tooltip className="field-tooltip-error">
					{(props.errors || meta.error) as ReactNode}
				</Form.Control.Feedback>
			</div>
		</Form.Group>
  );
});

export default TextField;
